import {useState} from 'react'
import {HTTP_STATUS_OK} from '../../Constants'
import {openPage} from '../../utils/NavigatorUtils'
import {changePassword} from '../authentication/AuthEndPoints'
import {useAuth} from '../authentication/AuthProvider'
import CustomForm from '../form-utils/CustomForm'
import {formLayout} from '../form/Constant'
import {severityNotification} from '../notification/NotificationConstant'
import {showNotification} from '../notification/NotificationService'
import {securityList} from './ProfileConstant'

const Security = () => {
    const {user} = useAuth()
    const [increment, setIncrement] = useState(1)
    const handleOnsubmit = async data => {
        let topPostData = {
            ...data,
            usernameOrEmail: user?.email ? user?.email : user?.username,
        }
        const responseStatus = await changePassword(topPostData)
        if (responseStatus === HTTP_STATUS_OK) {
            showNotification(
                severityNotification.success,
                'Change password successfully !',
            )
            openPage('/')
            setIncrement(prevState => prevState + 1)
        }
    }

    return (
        <div className="">
            {increment && (
                <CustomForm
                    dataList={securityList}
                    layout={formLayout.group}
                    onSubmit={handleOnsubmit}
                />
            )}
        </div>
    )
}

export default Security
